
(function () {
  let initialized = false;

  function waitForElement(selector, callback) {
    const el = document.querySelector(selector);
    if (el) return callback(el);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initUpload() {
    if (initialized) return;

    const calc = document.querySelector("#formula-calculator-section");
    if (!calc) return;

    waitForElement(
      "#formula-calculator-section button[type='button']",
      function (addBtn) {
        initialized = true;

        document.body.classList.add("js-ready");
        addBtn.style.display = "none";
        document.querySelector(".shopify-payment-button")?.remove();

        /* ---------- LIVE SUMMARY FUNCTION ---------- */
        function updateSummary() {
          let summary = document.querySelector(".upload-summary");
          if (!summary) {
            summary = document.createElement("div");
            summary.className = "upload-summary";
            summary.style.display = "none"; // hidden until accordion is clicked
            form.before(summary);           // sits above the form, outside it
          }

          const shapeVal =
            calc.querySelector('input[name="shape"]:checked')?.value || "";
          const sizeVal = calc.querySelector("#size")?.value || "";
          const finishVal =
            calc.querySelector('input[name="finish"]:checked')?.value || "";
          const qtyVal = calc.querySelector("#qty")?.value || "";
          const isCustomQty = qtyVal === "Custom Quantity";
          const customQtyVal = isCustomQty
            ? calc.querySelector("#quantity")?.value || ""
            : "";
          const priceVal =
            document.querySelector('[final-result-price="true"]')
              ?.innerText || "0";

          summary.innerHTML = `
            <p><strong>Shape:</strong> ${shapeVal}</p>
            <p><strong>Size:</strong> ${sizeVal}</p>
            <p><strong>Finish:</strong> ${finishVal}</p>
            <p><strong>Quantity:</strong> ${qtyVal}</p>
            ${
              customQtyVal
                ? `<p><strong>Custom Quantity:</strong> ${customQtyVal}</p>`
                : ""
            }
            <p><strong>Price:</strong> $${priceVal}</p>
          `;

          // Changing the number format whenever the summary updates
          // if (!isNaN(Number(document.querySelector('#formula-2 div').textContent))) {
          //   document.querySelector('#formula-2 div').textContent = Number(document.querySelector('#formula-2 div').textContent).toFixed(2).toLocaleString()
          // }

          // if (!isNaN(Number(document.querySelector('#formula-2 div').textContent))) { document.querySelector('#formula-2 div').textContent = 
          //     Number(document.querySelector('#formula-2 div').textContent)
          //     .toLocaleString(undefined, {
          //     minimumFractionDigits: 2,
          //     maximumFractionDigits: 2
          //     });
          //   }
            setTimeout(() => {
              const formulaEl = document.querySelector('#formula-2 div');

              if (formulaEl) {
                const value = Number(formulaEl.textContent.replace(/,/g, ''));

                if (!isNaN(value)) {
                  formulaEl.textContent = value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });
                }
              }
            }, 500);
        }

        /* ---------- HIDE artwork fields initially ---------- */
        const artwork = [];
        ["8", "9", "10", "11"].forEach((order) => {
          calc
            .querySelectorAll('[style*="order:' + order + '"]')
            .forEach((el) => {
              el.style.visibility = "hidden";
              artwork.push(el);
            });
        });

        /* ---------- CREATE ACCORDION ---------- */
        const box = document.createElement("div");
        box.className = "upload-accordion disabled-upload";
        box.innerHTML = `
          <div class="upload-header">
            <div class="upload-subs">Upload Your Artwork</div>
          </div>
        `;
        addBtn.parentNode.insertBefore(box, addBtn);

        /* ---------- SLIDE AREA ---------- */
        const slide = document.createElement("div");
        slide.className = "slide-wrapper";
        artwork.forEach((el) => {
          slide.appendChild(el);
          el.style.visibility = "visible";
        });

        const form = calc.querySelector("#calculator-form");
        if (form) {
          form.appendChild(slide);
          form.appendChild(addBtn);
        }

        /* ---------- ENABLE WHEN OPTIONS SELECTED ---------- */
        calc.addEventListener("change", () => {
          // const shape = calc.querySelector('input[name="shape"]:checked');
          // const size = calc.querySelector("#size")?.value;
          // const finish = calc.querySelector('input[name="finish"]:checked');
          // const qty = calc.querySelector("#qty")?.value;
          // const productionTime = calc.querySelector("#select_production_time")?.value;
          // const labelUsage = calc.querySelector('input[name="label_usage"]:checked');
          
          // if (shape && size && finish && qty && productionTime && labelUsage) {
          //   console.log("Condition Met")
          //   box.classList.remove("disabled-upload");
          // } else {
          //   console.log("Condition failed")
          // }

          // Helper: check if a radio group has a checked value
          function getRadioValue(name) {
            const checked = calc.querySelector(`input[name="${name}"]:checked`);
            return checked ? checked.value : null;
          }

          // Define each field with its existence test and value getter
          const fields = [
            {
              name: 'shape',
              exists: () => calc.querySelector('input[name="shape"]') !== null,
              getValue: () => getRadioValue('shape')
            },
            {
              name: 'size',
              exists: () => calc.querySelector('#size') !== null,
              getValue: () => calc.querySelector('#size')?.value
            },
            {
              name: 'finish',
              exists: () => calc.querySelector('input[name="finish"]') !== null,
              getValue: () => getRadioValue('finish')
            },
            {
              name: 'qty',
              exists: () => calc.querySelector('#qty') !== null,
              getValue: () => calc.querySelector('#qty')?.value
            },
            {
              name: 'productionTime',
              exists: () => calc.querySelector('#select_production_time') !== null,
              getValue: () => calc.querySelector('#select_production_time')?.value
            },
            {
              name: 'labelUsage',
              exists: () => calc.querySelector('input[name="label_usage"]') !== null,
              getValue: () => getRadioValue('label_usage')
            }
          ];

          // Filter to only the fields that exist in the DOM
          const existingFields = fields.filter(field => field.exists());

          // Check if every existing field has a non‑empty value
          const allFilled = existingFields.every(field => {
            const value = field.getValue();
            return value != null && value !== '';
          });

          if (allFilled) {
            box.classList.remove("disabled-upload");
            console.log("Condition Met – all existing fields are filled");
          } else {
            console.log("Condition failed – some existing fields are missing values");
          }

          updateSummary();
        });

        /* ---------- PRICE AUTO UPDATE ---------- */
        const priceEl = document.querySelector('[final-result-price="true"]');

        if (priceEl) {
          new MutationObserver(updateSummary).observe(priceEl, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        /* ---------- CLICK UPLOAD ---------- */
        box.addEventListener("click", () => {
          if (box.classList.contains("disabled-upload")) return;

          box.classList.add("step-hidden");
          slide.style.maxHeight = (slide.scrollHeight + 10000) + "px";
          addBtn.style.display = "block";

          /* HIDE external RTE content */
          
          document
          .querySelectorAll(".rte, .text-block, .rte-formatter")
          .forEach((el) => el.classList.add("step-hidden"));
          
          document.querySelector(".info-section")?.classList.add("step-hidden");
          

          /* CREATE upload layout */
          let uploadLayout = document.querySelector(".upload-view");

          if (!uploadLayout) {
            uploadLayout = document.createElement("div");
            uploadLayout.className = "upload-view";

            const back = document.createElement("div");
            back.className = "back-btn";
            back.innerHTML = "← Edit My Order";

            uploadLayout.appendChild(back);
            uploadLayout.appendChild(slide);
            uploadLayout.appendChild(addBtn);

            // FIX 1: append to form, not calc — keeps all inputs inside the <form> tag
            form.appendChild(uploadLayout);

            /* ---------- BACK BUTTON ---------- */
            back.onclick = function () {
              uploadLayout.classList.remove("active");
              box.classList.remove("step-hidden");

              /* HIDE summary when returning to calculator */
              const summary = document.querySelector(".upload-summary");
              if (summary) summary.style.display = "none";

              // FIX 3: un-hide form's direct children (not calc's)
              form
                .querySelectorAll(":scope > *:not(.upload-view)")
                .forEach((el) => el.classList.remove("step-hidden"));

              document
                .querySelectorAll(".rte, .text-block, .rte-formatter")
                .forEach((el) => el.classList.remove("step-hidden"));

              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });

              console.log(`calc.offsetTop - 120: ${calc.offsetTop - 120}`)
              setTimeout(updateSummary, 100);
            };
          }

          // FIX 2: hide form's direct children (not calc's) so uploadLayout stays visible
          form
            .querySelectorAll(":scope > *:not(.upload-view)")
            .forEach((el) => el.classList.add("step-hidden"));

          /* SHOW summary above the form */
          updateSummary();
          const summary = document.querySelector(".upload-summary");
          if (summary) summary.style.display = "block";

          setTimeout(() => uploadLayout.classList.add("active"), 50);

          // slide.scrollIntoView({
          //   behavior: "smooth",
          //   block: "start",
          // });
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });





//           const requiredFields = [
//   "#label_use",
//   "#custom",
//   "#quantity",
//   "#enter_url_for_file",
//   "#upload_artwork"
// ];

// const removeRequiredFromInputFields = () => {
//   for (const selector of requiredFields) {
//     const el = document.querySelector(selector);
//     if (el) {
//       el.removeAttribute("required");
//       console.log(`[PBF] Required removed from: ${selector}`);
//     } else {
//       console.warn(`[PBF] Field not found: ${selector}`);
//     }
//   }
// };

// // Fix 1: Run immediately on load — no need to tie this to a click at all.
// // Attributes are stripped once and stay stripped.
// removeRequiredFromInputFields();

// // Fix 2: Patch calculate_pbf to guard against undefined global `event`
// // when it is called from inside a Promise (e.g. after file upload completes).
// const _orig_calculate_pbf = window.calculate_pbf;
// window.calculate_pbf = function(element) {
//   if (!element && !window.event) {
//     // Mock the global event object so event.preventDefault() doesn't crash
//     window.event = { preventDefault: () => {} };
//     const result = _orig_calculate_pbf.call(this, element);
//     window.event = undefined; // clean up after
//     return result;
//   }
//   return _orig_calculate_pbf.call(this, element);
// };


// (function () {

//   /**
//    * PROBLEM:
//    * audify.js reads total_price by looping over all [total-price="true"] fields
//    * and OVERWRITES total_price on every iteration — so whichever field is LAST
//    * in the DOM wins. Currently formula_3 (discount, price="0") is last, so
//    * total_price always ends up as 0, triggering "No calculation perform".
//    *
//    * FIX:
//    * 1. Move formula_2 (the actual price field) to be last in DOM so it wins the loop.
//    * 2. Force calculate_pbf() to run on click (capture phase) so formula_2's
//    *    price attribute is freshly computed before audify.js reads it.
//    */

//   const PRICE_FORMULA_ID  = "formula_2";   // the field that holds the real price
//   const SHOP              = "7hd1xe-cz.myshopify.com";
//   const ADD_TO_CART_BTN   = `button[shop="${SHOP}"]`;

//   /* ── Step 1: Re-order formula_2 to be last among [total-price="true"] fields ── */
//   const reorderPriceFormula = () => {
//     const priceField = document.getElementById(PRICE_FORMULA_ID);
//     if (!priceField) {
//       console.warn(`[PBF Fix] #${PRICE_FORMULA_ID} not found — skipping reorder.`);
//       return;
//     }
//     // Append to parent moves it to the end of the sibling list,
//     // making it the last node the forEach loop reads.
//     priceField.parentNode.appendChild(priceField);
//     console.log(`[PBF Fix] #${PRICE_FORMULA_ID} moved to last position among total-price fields.`);
//   };

//   /* ── Step 2: Force a fresh calculation so formula_2 price attr is up to date ── */
//   const forceCalculation = () => {
//     if (typeof calculate_pbf === "function") {
//       calculate_pbf(true); // pass truthy → skips event.preventDefault() inside
//       console.log(`[PBF Fix] calculate_pbf() forced before Add to Cart.`);
//     } else {
//       console.warn("[PBF Fix] calculate_pbf() not found on window.");
//     }
//   };

//   /* ── Step 3: Attach both steps to Add to Cart (capture phase = runs first) ── */
//   const attachFix = () => {
//     const btn = document.querySelector(ADD_TO_CART_BTN);
//     if (!btn) {
//       console.warn("[PBF Fix] Add to Cart button not found.");
//       return;
//     }

//     btn.addEventListener(
//       "click",
//       () => {
//         forceCalculation(); // ensure formula_2 has latest price
//         reorderPriceFormula(); // ensure formula_2 is read last in the loop
//       },
//       { capture: true } // fires BEFORE audify.js click handler reads total_price
//     );

//     console.log("[PBF Fix] Listener attached to Add to Cart button.");
//   };

//   /* ── Run once DOM is ready ── */
//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", attachFix);
//   } else {
//     attachFix();
//   }

// })();
        });
      }
    );
  }

  /* ---------- SHOPIFY SAFE ---------- */
  document.addEventListener("DOMContentLoaded", initUpload);
  document.addEventListener("shopify:section:load", initUpload);
})();

// custom-shap-js-start
(function initCalculatorHeadings() {
  // Heading numbers mapping
  var headingNumbers = {
    "Choose Your Shape": "1",
    "Select Size": "2",
    "Select Finish": "3",
    "Select Quantity": "4",
    // "Select Production Time": "5",
    "Label Usage": "5"
  };

  var headings = document.querySelectorAll("#calculator-form .af-mt-10.af-mb-5");

  // Retry if headings not yet loaded
  if (!headings.length) {
    setTimeout(initCalculatorHeadings, 100);
    return;
  }

  headings.forEach(function(heading) {
    var parentWrapper = heading.parentElement;
    var headingText = heading.textContent.trim();

    // =========================
    // RADIO BUTTONS
    // =========================
    if (parentWrapper.classList.contains("af-my-10") && parentWrapper.querySelector(".af-radio-buttons")) {
      heading.classList.add("has-radio");
      if (headingNumbers[headingText]) {
        heading.setAttribute("data-number", headingNumbers[headingText]);
      }

      // Special case: Label Usage
      if (headingText === "Label Usage") {
        parentWrapper.classList.add("order-15");
      }

      var radios = parentWrapper.querySelectorAll("input[type='radio']");
      radios.forEach(function(radio) {
        radio.addEventListener("change", function() {
          // Remove active from all radios
          radios.forEach(function(r) {
            var wrap = r.closest(".input-wrapper, .af-radio");
            if (wrap) wrap.classList.remove("active");
          });

          // Add active to selected radio
          var selectedWrap = radio.closest(".input-wrapper, .af-radio");
          if (selectedWrap) selectedWrap.classList.add("active");

          // Add active to parent wrapper and heading
          parentWrapper.classList.add("active");
          heading.classList.add("active");
        });
      });
    }

    // =========================
    // SELECT ELEMENTS
    // =========================
    var select = heading.nextElementSibling;
    if (select && select.tagName === "SELECT") {
      // Wrap heading + select if not already wrapped
      if (!parentWrapper.classList.contains("input-wrapper")) {
        var wrapper = document.createElement("div");
        wrapper.className = "input-wrapper wrapper-select";
        parentWrapper.insertBefore(wrapper, heading);
        wrapper.appendChild(heading);
        wrapper.appendChild(select);
        parentWrapper = wrapper;
      }

      if (headingNumbers[headingText]) {
        heading.classList.add("has-select");
        heading.setAttribute("data-number", headingNumbers[headingText]);
      }

      select.addEventListener("change", function() {
        if (select.value) {
          parentWrapper.classList.add("active");
          heading.classList.add("active");
        } else {
          parentWrapper.classList.remove("active");
          heading.classList.remove("active");
        }
      });
    }
  });
})();
// custom-shap-js-end


window.sections = window.sections || {};
document.addEventListener("DOMContentLoaded", function(){
  if(typeof sections === "undefined"){
    window.sections = {};
  }
});



// Function to add classes to parent and spans dynamically
function observeAndAddClassesForOrder1(parentClassName, spanClassName) {
    function applyClasses() {
        // Select all .af-my-10 divs
        const divs = document.querySelectorAll('.af-my-10');
        divs.forEach(div => {
            // Check if style.order is 1 and class not already added
            if (div.style.order === '1' && !div.classList.contains(parentClassName)) {
                // Add class to parent
                div.classList.add(parentClassName);

                // Add class to all spans inside .af-radio-buttons
                const spans = div.querySelectorAll('.af-radio-buttons span');
                spans.forEach(span => {
                    span.classList.add(spanClassName);
                });
            }
        });
    }

    // Initial run for existing content
    applyClasses();

    // Observe DOM for dynamically added elements
    const observer = new MutationObserver(applyClasses);
    observer.observe(document.body, { childList: true, subtree: true });
}

// Call the function for order 1
observeAndAddClassesForOrder1('custom-parent', 'custom-span');





// Function to add class to .af-mt-10.af-mb-5 inside order 11
function addClassToOrder11Label(className) {
    function applyClass() {
        // Select all parent divs with class .af-my-10
        const divs = document.querySelectorAll('.af-my-10');
        divs.forEach(div => {
            // Target only order 11
            if (div.style.order === '11') {
                // Select the inner .af-mt-10.af-mb-5 element
                const labelDiv = div.querySelector('.af-mt-10.af-mb-5');
                if (labelDiv && !labelDiv.classList.contains(className)) {
                    labelDiv.classList.add(className);
                }
            }
        });
    }

    // Initial run
    applyClass();

    // Observe DOM for dynamically added elements
    const observer = new MutationObserver(applyClass);
    observer.observe(document.body, { childList: true, subtree: true });
}

// Call the function for order 11
addClassToOrder11Label('custom-label');

(function () {

  function fixDollarPosition() {
    const el = document.querySelector('#formula-2 [final-result-price]');
    if (!el) return;

    let text = el.textContent.trim();

    if (text.endsWith('$')) {
      text = text.replace('$', '').trim();
      el.textContent = '$' + text;
    }
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', fixDollarPosition);

  // Auto update 
  const observer = new MutationObserver(fixDollarPosition);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

})();


// next step  hide btn s 
(function () {

  function toggleElements() {

    const nextStepActive = document.querySelector('.upload-view.active');

    const readMoreBtn = document.querySelector('.read-more-btn');
    const materialBox = document.querySelector('.material-details-box');
    const ratingBox = document.querySelector('.rating-wrapper');

    if (nextStepActive) {

      if (readMoreBtn) {
        readMoreBtn.style.display = 'none';
      }

      if (materialBox) {
        materialBox.style.display = 'none';
      }

      if (ratingBox) {
        ratingBox.style.display = 'none';
      }

    } else {

      if (readMoreBtn) {
        readMoreBtn.style.display = '';
      }

      if (materialBox) {
        materialBox.style.display = '';
      }

      if (ratingBox) {
        ratingBox.style.display = '';
      }

    }
  }

  // first load
  toggleElements();

  // continuously check
  setInterval(toggleElements, 300);

})();



function updatePriceDollarPosition() {
  document.querySelectorAll('calculation-result [final-result-price]').forEach(function(el) {

    let val = parseFloat(
      el.textContent.replace(/[$,]/g, '').trim()
    );

    if (!isNaN(val)) {
      el.textContent = val.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  });
}

// initial run
document.addEventListener('DOMContentLoaded', function () {
  updatePriceDollarPosition();
});

// re-run after dynamic updates
setInterval(updatePriceDollarPosition, 200);